import { exportFile } from "~/lib/exportFile.js"

export const splitText = '~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~'


export const ExportCluster = (cluster, profile, club) => {

    // Simplified scope of data, without ID's and initial order
    const data = {
        name: cluster.name,
        description: cluster.description,
        curriculum_versie: cluster.curriculum_versie || 'v1',
        is_dto: cluster.is_dto,
        category: cluster.category?.map(c => {
            return {
                order: c.order,
                name: c.name,
                label: c.label ? c.label : c.name,
                description: c.description,
                hide: c.hide || false,
                bevoegdheid: c.bevoegdheid.map(b => {
                    return {
                        order: b.order,
                        name: b.name,
                        label: b.label ? b.label : b.name,
                        easa_key: b.easa_key,
                        description: b.description,
                        endorse_title: b.endorse_title,
                        endorse_body: b.endorse_body,
                        geldigheid: b.geldigheid,
                        valid_doy: b.valid_doy,
                        days_warning: b.days_warning,
                        group_key: b.group_key,
                        remove_group_key: b.remove_group_key,
                        scoring: b.scoring,
                        has_remark: b.has_remark,
                    }
                })
            }
        })
    }

    const txt = `GlidingApp Export DTO program "${cluster.name}"
Date exported: ${new Date()}

Curriculum version: ${cluster.curriculum_versie || 'v1'}
Description: ${cluster.description}

Is DTO: ${cluster.is_dto ? 'yes' : 'no'}

---
Originating club: ${club.full_name}
Contactperson: ${profile.name} via ${profile.email}

Details to the program can be added here:
-
-
-
-


For questions, please email contact@gliding.app




TECHNICAL DATA - PLEASE DO NOT ALTER AFTER THIS
${splitText}
${JSON.stringify(data)}
`

    exportFile(txt, `${club.name} - ${cluster.name} - ${cluster.curriculum_versie || 'v1'}.txt`)
}